<template>
    <div class="quotation-form">
        <el-form button-class="btn btn-sm btn-primary btn-rounded font-bold" @submit="submit" :loading="loading" :success="success" :error="server_error" :submit-text="translations.send_label" :disclaimer="translations.required_text">
            <h3 class="h5 mb-16">Details</h3>
            <el-input v-model="formData.sizes" rules="required" :label="translations.sizes_label" class="mb-16"></el-input>
            <el-input v-model="formData.amount" type="number" rules="required" :label="translations.amount_label" class="mb-16"></el-input>
            <el-input v-model="formData.pictures" :multiple="true" :placeholder="'Sleep uw foto’s <span class=\'link\'>hier</span> naartoe of zoek op uw apparaat.'" type="fileupload" rules="required" :label="translations.pictures_label" class="mb-16"></el-input>
            <el-input v-model="formData.description" rules="required" :label="translations.message_label" type="textarea" class="mb-40"></el-input>
            <h3 class="h5 mb-16">Contactgegevens</h3>
            <el-input v-model="formData.name" rules="required" :label="translations.name_label" class="mb-16"></el-input>
            <el-input v-model="formData.phone" :rules="{ required: true, regex: /(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/ }" :label="translations.phone_label" class="mb-16"></el-input>
            <el-input v-model="formData.email" rules="required|email" :label="translations.email_label" class="mb-40"></el-input>
            <h3 class="h5 mb-16">Bedrijfsgegevens</h3>
            <el-input v-model="formData.company" rules="required" :label="translations.company_label" class="mb-16"></el-input>
            <el-input v-model="formData.address" rules="required" :label="translations.address_label" class="mb-16"></el-input>
            <el-input v-model="formData.vat_number" rules="required" :label="translations.vat_number_label" class="mb-16"></el-input>
            <p class="text-14 text-primary opacity-70 mb-24" v-html="translations.privacy_policy"></p>
        </el-form>
    </div>
</template>

<script>
import hasForm from '@mixins/components/has-form';
import { serialize } from 'object-to-formdata';

export default {
    name: 'Forms.QuotationForm',

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            formData: {
                sizes: '',
                amount: null,
                pictures: [],
                description: '',
                name: '',
                phone: '',
                email: '',
                company: '',
                address: '',
                vat_number: '',
            },
        };
    },

    methods: {
        submit() {
            this.beforeSubmit();

            const formData = serialize(this.formData);

            axios
                .post(`/api/used-form?locale=${document.documentElement.lang}`, formData)
                .then(response => {
                    this.handleSuccess();
                })
                .catch(e => this.handleError(e));
        },
    },
};
</script>
